import { UserAsset } from '@interfaces';
import { createAction, props } from '@ngrx/store';

export const loadDecisionDocuments = createAction(
  '[Decision-Documents] Load Decision Documents',
  props<{ userProcessId: string; asConsultant?: boolean; errorMessageKey?: string }>()
);
export const loadDecisionDocumentsSuccess = createAction(
  '[Decision-Documents] Load Decision Documents Success',
  props<{ documents: UserAsset[] }>()
);
export const loadDecisionDocumentsError = createAction('[Decision-Documents] Load Decision Documents Error');

export const removeDecisionDocument = createAction(
  '[Decision-Documents] Remove Decision Document',
  props<{
    userProcessId: string;
    userAsset: UserAsset;
    asConsultant?: boolean;
    successMessageKey?: string;
    errorMessageKey?: string;
    reloadErrorMessageKey?: string;
  }>()
);
export const removeDecisionDocumentSuccess = createAction(
  '[Decision-Documents] Remove Decision Document Success',
  props<{
    userProcessId: string;
    userAssetId: string;
    fileOriginalName: string;
    asConsultant?: boolean;
    reloadErrorMessageKey?: string;
  }>()
);
export const removeDecisionDocumentError = createAction(
  '[Decision-Documents] Remove Decision Document Error',
  props<{ userAssetId: string }>()
);
